import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import {
  searchSubs,
  changeQuickMdn,
  quickSetServiceAddress,
} from 'actions/quickSubs';
import {
  findPurchase,
  createPurchase,
  createLineItem,
} from 'actions/purchases';
import BaseModal from '../BaseModal';
import Spinner from 'components/Spinner';
import ChangeMdnModalForm from './ChangeMdnModalForm';
import { transformErrors } from 'helpers/errors';
import FormError from 'components/FormError';
import { getSearchQuickSubs } from 'reducers';
import { BIG_PAGE_SIZE } from '../../../constants';

import styles from './styles.module.scss';

class QuickChangeMdnModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      purchaseId: null,
      purchaseError: null,
    };
    this.isPurchasePage = Boolean(this.props.purchaseId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.isPurchasePage && !prevProps.isOpen && this.props.isOpen) {
      this.fetchSubs();
    }
  }

  fetchSubs = async () => {
    const { userId, searchSubs } = this.props;
    try {
      await searchSubs(1, { user_profile: userId }, BIG_PAGE_SIZE);
    } catch (e) {
      toast.error('Failed to load quick subscription');
    }
  };

  handleGenerateInvoice = async () => {
    const { userId, createPurchase, createLineItem } = this.props;

    this.setState({ loading: true, purchaseError: null, purchaseId: null });
    try {
      const purchase = await createPurchase({ user_profile: userId });
      await createLineItem(purchase.id, {
        item_type: 'mdn_change_fee',
        item_id: '',
      });
      this.setState({ purchaseId: purchase.id });
    } catch (e) {
      const error = e?.errors || e;
      const purchaseError = transformErrors(Object.keys(error), error);
      this.setState({ purchaseError });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChangeMdn = (values) => {
    const {
      purchaseId,
      quickSetServiceAddress,
      closeModal,
      changeMdn,
      findPurchase,
    } = this.props;
    const { sub_id, ...addressValues } = values;
    const subId = this.props.subId || sub_id;
    this.setState({ loading: true });

    // set servise address if adress fields provided
    const needToChangeAddress = !!Object.values(addressValues).find((value) =>
      value.trim(),
    );
    const setAddressPromise = needToChangeAddress
      ? quickSetServiceAddress(subId, addressValues)
      : Promise.resolve();

    return setAddressPromise
      .then(() => changeMdn(subId))
      .then(() => {
        closeModal();
        toast.success('MDN change requested');
        return Promise.resolve();
      })
      .then(() => {
        if (this.isPurchasePage) {
          return findPurchase(purchaseId);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { isOpen, quickSubs, closeModal } = this.props;
    const { loading, purchaseId, purchaseError } = this.state;

    return (
      <BaseModal
        isOpen={isOpen}
        title="Change MDN"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        {!this.isPurchasePage && (
          <React.Fragment>
            <div className="d-flex-vc">
              <button
                className="btn btn-primary mar-r"
                onClick={this.handleGenerateInvoice}
              >
                Generate MDN change invoice
              </button>
              {purchaseId && (
                <Link to={`/purchases/${purchaseId}/view`}>View Purchase</Link>
              )}
            </div>
            {purchaseError && (
              <React.Fragment>
                <br />
                <FormError error={purchaseError} />
              </React.Fragment>
            )}
            <hr />
          </React.Fragment>
        )}
        <ChangeMdnModalForm
          quickSubs={quickSubs}
          onSubmit={this.handleChangeMdn}
          isPurchasePage={this.isPurchasePage}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

const mapStateToProps = (state) => ({
  quickSubs: getSearchQuickSubs(state),
});

const mapDispatchToProps = {
  changeMdn: changeQuickMdn,
  searchSubs: searchSubs,
  quickSetServiceAddress,
  findPurchase,
  createPurchase,
  createLineItem,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuickChangeMdnModal);
